import React from 'react';

const IconsGridCard = ({ card }) => {
    const navigatePage = (data) => {
        if (data.NavigationType === "3") {
            const currentQueryParams = window.location.search;
            var newQueryParams = removeQueryParam(currentQueryParams, 'type');
            newQueryParams = removeQueryParam(newQueryParams, 'typeId');
            newQueryParams = removeQueryParam(newQueryParams, 'pageId');

            if (data.FSN === "103") {
                localStorage.setItem("productId", data.FAI.productId);
                localStorage.setItem("FSN", data.FSN);
                window.location.href = `/product_detail_page${newQueryParams}`;
              } else if (data.FSN === "125") {
                localStorage.setItem("type", data.FAI.type);
                localStorage.setItem("typeId", data.FAI.typeId);
                localStorage.setItem("FSN", data.FSN);
                window.location.href = `/store_category_grid_page${newQueryParams}`;
              }
        }
    };

    const removeQueryParam = (url, param) => {
        const urlObj = new URL(url, window.location.origin); // Create a URL object
        urlObj.searchParams.delete(param); // Remove the parameter
        return urlObj.search; // Return the new query string
    };

    return (
        <div style={{ padding: '1rem',backgroundColor: "#fff4e3", borderRadius: '8px' }}>
            {card.cardMetaData.title &&
                <label style={{ fontWeight: 'bold', marginBottom: '1rem', display: 'block', color: '#681517' }}>
                    {card.cardMetaData.title}
                </label>
            }
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: '1rem',
                    backgroundColor: "#fff4e3",
                }}>
                {card.cardData.map((category) => (
                    <div
                        onClick={() => navigatePage(category.data.onTap)}
                        key={category.id}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            margin: '5px',
                            backgroundColor: "#fff4e3",
                        }}
                    >
                        <img
                            src={category.data.imageUrl}
                            alt={category.name}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                borderRadius: '10%',
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default IconsGridCard;
